import Vue from 'vue'
import Router from 'vue-router'
import zh_cn from '../api/languages/zh-cn'
import en from '../api/languages/en-us';
import  { getUrlKey } from '../utils/utils'
const Login = resolve => require(['../views/login/index'], resolve);
const Meetindex = resolve => require(['../views/WebConference/index'], resolve);
const Conference =  resolve => require(['../views/WebConference/conference'], resolve);
const Notfount =  resolve => require(['../views/err/404'], resolve);
Vue.use(Router);
let titie = null;
let querylang = getUrlKey('lang',window.location.href)
let lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
lang = lang.substr(0, 2);
let localStorageLang = JSON.parse(localStorage.getItem('locale'));
if(querylang == 'auto'){
	titie = lang == 'zh' ? zh_cn.Video_CONFERENCE_HOME_NAME : en.Video_CONFERENCE_HOME_NAME
}else{
	const curSelect = localStorageLang || lang;
	titie =  curSelect == 'zh' ? zh_cn.Video_CONFERENCE_HOME_NAME : en.Video_CONFERENCE_HOME_NAME;
}
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,

      meta:{
        title:titie
      }
    },
    {
      path: '/',
      name: 'meetindex',
      component: Meetindex,
      meta: {
          title:titie
      }
    },
    {
      path: '/conference',
      name: 'conference',
      component: Conference,
      meta:{
          title:titie
      }
    },
    {
      path: '*',
      name: 'notfount',
      component: Notfount
    }
  ]
})
